import { Attachment } from '../../@types/GetQuotation'
import { DocumentsToList } from '../../@types/SimulationSummaryDownload'
import { DocumentToList as DocumentToListSubmitProposal } from '../../@types/SubmitProposal'
import { ENV } from '../../Environment'
import { useDownloadFileDocument } from '../../hooks/api/useDownloadFileDocument'

export const useDownloadDocuments = () => {
  const downloadFile = useDownloadFileDocument()

  async function downloadFileCommon(documentItem: DocumentsToList) {
    downloadFile.mutate({
      documentName: documentItem.documentName || '',
      documents: [
        {
          documentExternalId: documentItem?.documentExternalId,
          documentManagementSystem: documentItem?.managementSystemCode,
          documentReference: documentItem.keyRef || '',
        },
      ],
    })
  }

  async function downloadFileQuotation(documentItem: Attachment) {
    downloadFile.mutate({
      documentName: documentItem.documentName || '',
      documents: [
        {
          documentExternalId: documentItem?.idExternal || '',
          documentManagementSystem: ENV().REDDOC,
        },
      ],
      useFileExtension: true,
    })
  }

  async function downloadFileFromSubmitProposal(
    documentItem: DocumentToListSubmitProposal,
  ) {
    downloadFile.mutate({
      documentName: documentItem.name || '',
      documents: [
        {
          documentExternalId: documentItem?.externalId,
          documentManagementSystem: documentItem?.managementSystemCode,
          documentReference: documentItem.keyRef || '',
        },
      ],
    })
  }

  return {
    downloadFile,
    downloadFileCommon,
    downloadFileQuotation,
    downloadFileFromSubmitProposal,
  }
}
